import { render, staticRenderFns } from "./PaxelMarketBasicService.vue?vue&type=template&id=76e1b826&"
import script from "./PaxelMarketBasicService.vue?vue&type=script&lang=js&"
export * from "./PaxelMarketBasicService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports